<template>
  <b-modal
    v-model="visible"
    :title="$t('order.patient-info.modal.add-title')"
    hide-footer
    size="lg"
    @hidden="resetForm"
  >
    <validation-observer ref="addPatientValidation">
      <form @submit.prevent="submitNewPatient">
        <order-patient-form
          :patient="newPatient"
          :patient-index="0"
          :full-validation="true"
          :statuses-when-dispatcher-can-edit="[]"
          :is-disabled-fn="() => false"
          :commit-handler="() => {}"
          :convert-from-annual="convertFromAnnual"
        />
        <div class="text-right mt-1">
          <b-button
            variant="outline-secondary"
            class="mr-50"
            @click="close"
          >
            {{ $t('shared.button.cancel') }}
          </b-button>
          <b-button
            variant="primary"
            :disabled="addingPatient"
            @click="submitNewPatient"
          >
            <b-spinner
              v-if="addingPatient"
              small
              class="mr-50"
            />
            {{ $t('order.patient-info.modal.add-submit') }}
          </b-button>
        </div>
      </form>
    </validation-observer>
  </b-modal>
</template>
<script>
import moment from 'moment'
import { ValidationObserver } from 'vee-validate'
import { parseRequestError } from '@/helpers/helpers'
import { createEmptyPatientInfo } from '@/helpers/patient'
import OrderPatientForm from '@/views/orders/partials/OrderPatientForm.vue'

export default {
  name: 'AddPatientModal',
  components: {
    ValidationObserver,
    OrderPatientForm,
  },
  props: {
    canAddPatient: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
      addingPatient: false,
      newPatient: createEmptyPatientInfo(),
    }
  },
  computed: {
    order() {
      return this.$store.getters['order/getOrderData']
    },
  },
  methods: {
    open() {
      if (!this.canAddPatient) {
        return
      }
      this.resetForm()
      this.visible = true
    },
    close() {
      this.visible = false
    },
    resetForm() {
      this.newPatient = createEmptyPatientInfo()
      this.addingPatient = false
    },
    submitNewPatient() {
      if (!this.canAddPatient || this.addingPatient) {
        return
      }

      this.$nextTick(() => {
        const observer = this.$refs.addPatientValidation
        if (!observer) {
          return
        }

        observer.validate()
          .then(valid => {
            if (!valid || !this.isNewPatientValid()) {
              return
            }

            this.addingPatient = true
            this.$store.dispatch('order/createOrderPatientData', {
              orderId: this.order.id,
              data: this.newPatient,
            })
              .then(response => this.$store.dispatch('order/fetchOrderById', this.order.id)
                .then(() => response))
              .then(response => {
                window.toast.notify.success(this.$t('order.notify.edit.success_title'))
                this.$emit('patient-added', response?.data?.patientInfoId || null)
                this.close()
              })
              .catch(err => {
                parseRequestError(err)
              })
              .finally(() => {
                this.addingPatient = false
              })
          })
      })
    },
    isNewPatientValid() {
      return !!(this.newPatient?.surname && this.newPatient?.name)
    },
    convertFromAnnual(patient) {
      if (!patient || patient.age === null || patient.age === undefined || patient.age === '') {
        return
      }

      const ageString = patient.age.toString()
      const yearShort = parseInt(moment().format('YY'), 10)
      const yearFull = parseInt(moment().format('YYYY'), 10)
      let nextAge

      if (ageString.length < 3) {
        nextAge = yearShort < patient.age
          ? yearShort - patient.age + 100
          : yearShort - patient.age
      } else {
        nextAge = yearFull - patient.age
      }

      this.$set(patient, 'age', nextAge)
    },
  },
}
</script>
